<template>
  <div class="summary-details">
    <div class="filter-container">
      <div class="tips"><span><svg-icon icon-class="icon-font-warning" style="color: #488CE8;" /></span>{{ $t('tips.current_time_zone') }}</div>
      <div class="right">
        <span class="transTime">{{ $t('components.date') }}:</span>
        <el-date-picker
          v-model="search.times"
          class="picker"
          size="small"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="~"
          :start-placeholder="$t('components.start_date')"
          :end-placeholder="$t('components.end_date')"
        />
        <!-- 查询 -->
        <el-button class="search-btn" size="small" type="primary" icon="el-icon-search" @click="getMchRechargeInfo">{{ $t('components.search') }}</el-button>
      </div>
    </div>
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
        class="tableContainer"
      >
        <el-table-column :label="$t('components.date')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.statistics_date }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.commission')" align="center">
          <template slot-scope="scope">
            <span>{{ (Number(scope.row.commission_dis_in) + Number(scope.row.commission_pay_in) - Math.abs(scope.row.commission_refund_out) - Math.abs(scope.row.commission_reverse_out) - Math.abs(scope.row.payment_refund_commission_out)) | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.frozen_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.frozen_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.unfrozen_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.unfrozen_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.cash_out')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.cash_out | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.cashout_fail')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fail_withdraw_refund_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="hasReverse" :label="$t('data.reverse')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.reverse_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column :label="$t('data.abnormal_adjustment')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.abnormal_adjustment | toDivideWithDot }}</span>
          </template>
        </el-table-column> -->

        <el-table-column :label="$t('data.abnormal_adjustment_credit_balance')" align="center" min-width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.abnormal_adjustment_credit | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.abnormal_adjustment_credit_frozen')" align="center" min-width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.frozen_abnormal_adjustment_credit | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.abnormal_adjustment_debit_balance')" align="center" min-width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.abnormal_adjustment_debit | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.abnormal_adjustment_debit_frozen')" align="center" min-width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.frozen_abnormal_adjustment_debit | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.frozen_amount_balance')" align="center">
          <template slot-scope="scope">
            {{ scope.row.frozen_balance | toDivideWithDot }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.balance')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.balance | toDivideWithDot }}</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>

  </div>
</template>

<script>

import { fetchBalanceSummaryDetail } from '@/api/settlement/settlement'
import { appointDate } from '@/utils/index.js'
import { filterEmptyAttr } from '@/utils/common'
export default {
  name: 'Summary_Details',
  components: {
    Paginator: () => import('@/views/components/Paginator')
  },
  data() {
    return {
      search: {
        times: [appointDate(-3), appointDate()]
      },
      tableData: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      }
    }
  },
  computed: {
    hasReverse() {
      let flag = false
      const list = this.tableData || []
      list.forEach(item => {
        if (item.reverse_amount && item.reverse_amount !== '0') {
          flag = true
        }
      })
      return flag
    }
  },
  created() {
    this.getMchRechargeInfo()
  },
  methods: {
    getMchRechargeInfo(otherParams) {
      const params = this.getParams(otherParams)
      this.listLoading = true
      fetchBalanceSummaryDetail(params).then(res => {
        if (res.code === 10000) {
          const { total, list = [] } = res.data || {}
          this.listQuery.total = total
          this.listQuery.page = params.page ? params.page : 1
          this.tableData = list
        }
      }).finally(() => {
        this.listLoading = false
      })
    },

    getParams(otherParams = {}) {
      const { times = [] } = this.search
      let params = { start_date: times && times[0], end_date: times && times[1], ...otherParams }
      params = filterEmptyAttr(params)
      return params
    },

    onClickPaginator() {
      this.getMchRechargeInfo(this.listQuery)
    }
  }
}
</script>

<style lang="scss" scoped>
.summary-details{
   background-color: #fff;
   .transTime{
      display: inline-block;
      padding: 0 20px 10px 0;
      font-size: 14px;
      font-weight: 500;  font-family: 'Poppins-Medium';
  }
  .filter-container{
    margin-top: 14px;
    margin-bottom: 32px;
    text-align: right;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tips{
      text-align: left;
      padding-right: 40px;
      border-radius: 4px;
      border: 1px solid #D3D7DF;
      padding: 10px 12px;
      color: #7A869E;
      width: max-content;
      margin-right: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      span{
        padding-right: 11px;
      }
    }
    .right{
      min-width: max-content;
    }
  }
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
  .picker{
    margin-right: 10px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .status{
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
 .mb-10{
    margin-bottom: 10px;
  }
}

</style>
